import { BizAdAccountDetail } from '@kakao/mfa-container'
import useObserver from 'features/crux/mfa/hooks/useObserver'
import { useHistory, useParams } from 'react-router-dom'
import useWhiteBackground from './hooks/useWhiteBackground'
import { AD_PLATFORM_TYPE, CRUX_PHASE } from '../cruxConstants'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { refetchAdAccount } from '../../account/accountSlice'

const BizAdAccountDetailApp = () => {
  useWhiteBackground()
  const dispatch = useDispatch()
  const observer = useObserver()
  const history = useHistory()
  const { accountId: adAccountId } = useParams()
  const gotoAccountList = useCallback(() => {
    history.push('/adaccount/all')
  }, [history])
  const handleAdAccountDeleteFailed = useCallback(
    ({ reason }) => {
      if (reason === 'activeAdAccount') {
        history.push(`/${adAccountId}/dashboard`)
      } else if (reason === 'unfinishedDeposit') {
        history.push(`/${adAccountId}/settings/bizwallet/cash/by-assets`)
      } else if (reason === 'negativeBalance') {
        history.push(`/${adAccountId}/settings/bizwallet/cash`)
      } else if (reason === 'noLinkedTrack') {
        history.push(`/${adAccountId}/tracker`)
      }
    },
    [history, adAccountId]
  )
  const handleAdAccountNameChange = useCallback(() => {
    dispatch(refetchAdAccount())
  }, [dispatch])
  return (
    <BizAdAccountDetail
      phase={CRUX_PHASE}
      adAccountId={adAccountId}
      adPlatformType={AD_PLATFORM_TYPE}
      basePath={`/${adAccountId}/settings/adaccount`}
      observer={observer}
      onAdAccountDeleteCompleted={gotoAccountList}
      onAdAccountDeleteFailed={handleAdAccountDeleteFailed}
      onAdAccountMemberQuit={gotoAccountList}
      onAdAccountNameChange={handleAdAccountNameChange}
    />
  )
}
export default BizAdAccountDetailApp
